// extracted by mini-css-extract-plugin
export default {"tableTitle":"styles_tableTitle__fYiPX","icon":"styles_icon__HfEe9","wrapper":"styles_wrapper__pjDO4"};